import { Directive, HostListener, inject, Input } from '@angular/core';
import { AppInsightsService } from '../../core/services/app-insights/app-insights.service';

@Directive({
  selector: '[appInsightsEvent]',
  standalone: true,
})
export class AppInsightsEventDirective {
  private appInsightsService = inject(AppInsightsService);
  @Input('appInsightsEvent') payload!: { name: string; dims?: Record<string, unknown> };

  @HostListener('click')
  onClick() {
    if (this.payload?.name) {
      this.appInsightsService.trackEvent(this.payload.name, this.payload.dims);
    }
  }
}
